define('app-SearchResults/settings',[],function () {
    return {
        overallContainer: '#searchResults',
        tagsField: '#facetedSearchDate',
        searchStorageKey: 'searchResults',
        searchUrlKey: 'app-Search-Tags',
        searchNameKey: 'app-SearchResults',
        resultsStartFromKey: 'app-ResultsStartFrom'
    };
});
